import { flatten, min, reduce } from "lodash";

import { getEarningAmount } from "lib/helpers";
import { EarningByRegion } from "services/valuation/types";

function checkYAxisUpperDomain(
  acc: number | EarningByRegion,
  curr: number | EarningByRegion,
): number {
  if (!acc || !curr) {
    return 0;
  }
  const prevTotal = getEarningAmount(acc);
  const nextTotal = getEarningAmount(curr);
  return prevTotal < nextTotal ? nextTotal : prevTotal;
}

export function setYAxisUpperDomain(
  amounts: (number | EarningByRegion)[],
): number {
  const totalAmount = reduce(
    amounts,
    (acc, curr) => checkYAxisUpperDomain(acc, curr),
    0,
  );
  return totalAmount * 0.2;
}

export function setYAxisLowerDomain(
  amounts: (number | EarningByRegion)[],
): number {
  const allValues = flatten(
    amounts.map(item => {
      if (typeof item === "number") {
        return [item];
      }
      return Object.values(item);
    }),
  );
  const minAmount = min(allValues) ?? 0;
  return minAmount < 0 ? minAmount * 1.2 : 0;
}
